var exports = {
  "kL": "x61f99309--e68a5d--container",
  "R_": "x61f99309--e68a5d--heading",
  "x6": "x61f99309--e68a5d--button",
};

module.exports = exports;
